"use client";

import { credientialResetPwd } from "@/01-core/user/user";
import { Button } from "@/03-presenters/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/03-presenters/components/ui/form";
import RequiredLabel from "@/03-presenters/components/ui/required-label";
import { zodResolver } from "@hookform/resolvers/zod";
import { Loader2 } from "lucide-react";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useFormState, useFormStatus } from "react-dom";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { create } from "zustand";
import { Input } from "../../ui/input";
import { ResetPwdEmailVerificationForm } from "./ResetPwdEmailVerificationForm";
import { credientialResetPwdAction } from "./resetPwd.action";
type credientialResetPwdStore = {
  pending: boolean;
  setPending: (pending: boolean) => void;
};
const useCredientialResetPwdStore = create<credientialResetPwdStore>(set => ({
  pending: false,
  setPending: pending => set(() => ({
    pending
  }))
}));
export function CredientialResetPwdForm() {
  const router = useRouter();
  const [resetPwdState, resetPwdAction] = useFormState(
  // FIXME: credientialSignUpAction should be credientialResetPwdAction
  credientialResetPwdAction, {
    error: "",
    done: false
  });
  const pending = useCredientialResetPwdStore(state => state.pending);
  const form = useForm<z.infer<typeof credientialResetPwd>>({
    resolver: zodResolver(credientialResetPwd),
    mode: "onBlur",
    defaultValues: {
      email: "",
      code: "",
      password: "",
      passwordConfirm: ""
    }
  });
  const {
    setError
  } = form;
  const {
    formError
  } = resetPwdState;
  useEffect(() => {
    if (formError) {
      formError.forEach(err => {
        setError(err.field, {
          message: err.error,
          type: "value"
        });
      });
    }
  }, [formError, setError]);
  useEffect(() => {
    if (resetPwdState.done) {
      router.refresh();
    }
  }, [resetPwdState.done, router]);
  return <Form {...form} data-sentry-element="Form" data-sentry-component="CredientialResetPwdForm" data-sentry-source-file="ResetPwdForm.tsx">
      <form className="space-y-4" action={resetPwdAction}>
        <FormField control={form.control} name="email" render={({
        field
      }) => <FormItem>
              <FormLabel>
                <RequiredLabel>邮箱</RequiredLabel>
              </FormLabel>
              <FormControl>
                <Input id="email" placeholder="请输入邮箱" type="text" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} data-sentry-element="FormField" data-sentry-source-file="ResetPwdForm.tsx" />
        <FormField control={form.control} name="password" render={({
        field
      }) => <FormItem>
              <FormLabel>
                <RequiredLabel>密码</RequiredLabel>
              </FormLabel>
              <FormControl>
                <Input disabled={pending} id="password" placeholder="••••••••" type="password" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} data-sentry-element="FormField" data-sentry-source-file="ResetPwdForm.tsx" />
        <FormField control={form.control} name="passwordConfirm" render={({
        field
      }) => <FormItem>
              <FormLabel>
                <RequiredLabel>确认密码</RequiredLabel>
              </FormLabel>
              <FormControl>
                <Input disabled={pending} id="passwordConfirm" placeholder="••••••••" type="password" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} data-sentry-element="FormField" data-sentry-source-file="ResetPwdForm.tsx" />

        <FormField control={form.control} name="code" render={({
        field
      }) => <FormItem>
              <FormLabel>
                <RequiredLabel>邮箱验证码</RequiredLabel>
              </FormLabel>
              <div className="flex items-center gap-2">
                <FormControl>
                  <Input id="code" placeholder="请输入邮箱验证码" type="text" {...field} />
                </FormControl>
                {/* <EmailVerificationForm email={form.getValues("email")} /> */}
                <ResetPwdEmailVerificationForm setError={setError} email={form.getValues("email")} />
              </div>
              <FormMessage />
            </FormItem>} data-sentry-element="FormField" data-sentry-source-file="ResetPwdForm.tsx" />
        <SubmitBtn isValid={form.formState.isValid} data-sentry-element="SubmitBtn" data-sentry-source-file="ResetPwdForm.tsx" />
      </form>
    </Form>;
}
function SubmitBtn({
  isValid
}: {
  isValid: boolean;
}) {
  const {
    pending
  } = useFormStatus();
  const setPending = useCredientialResetPwdStore(state => state.setPending);
  useEffect(() => {
    setPending(pending);
  }, [pending, setPending]);
  return <Button className="gradient-btn h-10 w-full rounded-md font-medium text-white shadow-[0px_1px_0px_0px_#ffffff40_inset,0px_-1px_0px_0px_#ffffff40_inset]" type="submit" disabled={pending || !isValid} data-sentry-element="Button" data-sentry-component="SubmitBtn" data-sentry-source-file="ResetPwdForm.tsx">
      修改密码
      {pending ? <Loader2 className="ml-2 size-4 animate-spin" /> : <span>&rarr;</span>}
    </Button>;
}